import { TApplicationState } from '../../types/redux';

export function getIsReliable(state: TApplicationState): boolean {
  return state.newbuilding.isReliableV2 || false;
}
